import {fetchAndDeserialize, serializeToURLParameters} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';

import {
    brandCompareListSchema,
    brandCompareSchema,
    BrandCompareType,
    ReviewsCompetitorBrandsQueryType,
} from './review-competitors-type';

export async function fetchReviewCompetitorBrands(
    options: ReviewsCompetitorBrandsQueryType,
    mainFilterKey: string
): Promise<Array<BrandCompareType>> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters<ReviewsCompetitorBrandsQueryType>(options),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/competitors/?${searchParameters}`;

    return fetchAndDeserialize<Array<BrandCompareType>>(url, brandCompareListSchema);
}

export async function fetchReviewCustomerBrands(
    options: ReviewsCompetitorBrandsQueryType,
    mainFilterKey: string
): Promise<BrandCompareType> {
    const searchParameters = objectToUrlParameters({
        ...serializeToURLParameters<ReviewsCompetitorBrandsQueryType>(options),
        filter_key: mainFilterKey,
    });

    const url = `/v2/reviews-analytics/stats/competitors/my-brands/?${searchParameters}`;

    return fetchAndDeserialize<BrandCompareType>(url, brandCompareSchema);
}
